import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../components/Projects.css';

const pub = process.env.PUBLIC_URL;

const categories = ['All', 'Residential', 'Commercial', 'Industrial', 'Infrastructure'];

const allProjects = [
  { 
    id: 1, 
    title: 'Project 1', 
    description: 'Construction, Design', 
    image: `${pub}/project-1.jpg`, 
    categories: ['residential'] 
  },
  { 
    id: 2, 
    title: 'Project 2', 
    description: 'Construction, Design', 
    image: `${pub}/project-2.jpg`, 
    categories: ['residential'] 
  },
  { 
    id: 3, 
    title: 'Project 3', 
    description: 'Construction, Design', 
    image: `${pub}/project-3.jpg`, 
    categories: ['commercial'] 
  },
  { 
    id: 4, 
    title: 'Project 4', 
    description: 'Construction, Design', 
    image: `${pub}/project-4.jpg`, 
    categories: ['commercial'] 
  },
  { 
    id: 5, 
    title: 'Project 5', 
    description: 'Construction, Design', 
    image: `${pub}/project-5.jpg`, 
    categories: ['industrial'] 
  },
  { 
    id: 6, 
    title: 'Project 6', 
    description: 'Construction, Design', 
    image: `${pub}/project-6.jpg`, 
    categories: ['infrastructure'] 
  },
];

export default function Projects() {
  const [activeCat, setActiveCat] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    AOS.init({ duration: 700, once: false, delay: 50 });
  }, []);

  const filtered = allProjects.filter(p => {
    const matchesCat =
      activeCat === 'All' ||
      p.categories.includes(activeCat.toLowerCase());
    const matchesSearch =
      p.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCat && matchesSearch;
  });

  return (
    <>
      <section className="page-breadcrumb-section" data-aos="fade-up">
        <h1 className="section-title">Projects</h1>
        <p className="page-breadcrumb">
          <a href="/">Home</a> / <span>Projects</span>
        </p>
      </section>

      <section className="projects-section" data-aos="fade-up">
        {/* Filter Bar */}
        <div className="project-filter">
          {categories.map(cat => (
            <button
              key={cat}
              className={`filter-btn${activeCat === cat ? ' active' : ''}`}
              onClick={() => setActiveCat(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="project-search">
          <input
            type="search"
            placeholder="Search projects..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
          <button onClick={() => { /* optional: handle explicit search */ }}>
            <i className="fas fa-search" />
          </button>
        </div>

        {/* Grid */}
        <div className="projects-grid">
          {filtered.map(p => (
            <div className="project-card" key={p.id} data-aos="zoom-in">
              <div className="project-image">
                <img src={p.image} alt={p.title} />
              </div>
              <div className="project-info">
                <h3>{p.title}</h3>
                <p>{p.description}</p>
                <a href="#" className="btn-details">View Details</a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section" data-aos="fade-up">
        <div className="cta-content">
          <h2>Ready to Power Your Project?</h2>
          <p>Contact us today for a free consultation and quote.</p>
          <div className="cta-buttons">
            <a href="tel:+1234567890" className="btn btn-white">
              <i className="fas fa-phone" /> Call Now
            </a>
            <a href="/contact" className="btn btn-outline">
              <i className="fas fa-envelope" /> Email Us
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
